module.exports = __webpack_public_path__ + "img/hair_color_darkBlue.7782742.svg";